import PropTypes from "prop-types";
import { Label, Meter } from "react-aria-components";

import { twMerge } from "../../../../../helpers/twMerge";
import { PreviousButton } from "./PreviousButton";

const PERCENTAGE_FULL = 100;

export const ProgressMeter = ({
	totalSteps,
	currentStep,
	handlePrev,
	className,
	...props
}) => (
	<Meter
		value={((currentStep + 1) / totalSteps) * PERCENTAGE_FULL}
		minValue={0}
		maxValue={PERCENTAGE_FULL}
		label={`Step ${currentStep + 1}/${totalSteps}`}
		className={twMerge(
			"tw:relative tw:mx-5 tw:mt-5 tw:flex tw:items-center tw:justify-center tw:gap-4 tw:pl-10 tw:md:absolute tw:md:bottom-8 tw:md:left-8 tw:md:z-[1] tw:md:m-0 tw:md:flex-col tw:md:items-start tw:md:gap-2 tw:md:pl-0",
			className,
		)}
		{...props}
	>
		{({ percentage }) => (
			<>
				{currentStep > 0 && (
					<PreviousButton handlePrev={handlePrev} className="tw:md:hidden" />
				)}
				<div className="tw:order-1 tw:h-2 tw:w-full tw:overflow-hidden tw:rounded-full tw:bg-[#CCE7FF] tw:md:order-2 tw:md:w-[108px]">
					<div
						className="tw:h-full tw:rounded-full tw:bg-[#0756C0] tw:transition-all tw:duration-300 tw:ease-in-out"
						style={{ width: percentage + "%" }}
					/>
				</div>
				<Label className="tw:order-2 tw:shrink-0 tw:text-sm tw:leading-6 tw:font-medium tw:text-[#212121] tw:md:order-1">
					{`Step ${currentStep + 1}/${totalSteps}`}
				</Label>
			</>
		)}
	</Meter>
);

ProgressMeter.propTypes = {
	currentStep: PropTypes.number.isRequired,
	handlePrev: PropTypes.func.isRequired,
	totalSteps: PropTypes.number,
	className: PropTypes.string,
};
